import { RecuringJobLogRequest, RecuringJobLog } from '../schemas/RecuringJobLog.schema';
import { retrieveRecuringJobLog } from '../datasource/RecuringJobLog.datasource';

export async function getRecuringJobLog(params: RecuringJobLogRequest): Promise<RecuringJobLog[]> {
    const response = await retrieveRecuringJobLog(params);
    return response.data;
}
